import ruLocale from 'element-ui/lib/locale/lang/ru-RU' //引入element语言包
const ru = {
  posterPage: {
    title1:'Подписка уже в сети!',
    title2:'Продление подписки, обновление привилегий!',
    title3:'Эксклюзивная скидка, продление более рентабельно',
    title4:'Чтобы получить код обмена, вы можете проконсультироваться с продавцом, который покупает оборудование',
    title5:'Приоритетные функции опыта',
    function1:'Функциональные подробности:',
    function2:'Продление базового обслуживания (синхронный перевод, ассистент по обслуживанию конференций, умный помощник).',
    function3:'Подписка на услуги с добавленной стоимостью (оффлайн - перевод, аудио - и видеозвонок перевод)...',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Код обмена',
    ValueAddedServices: 'Услуги с добавленной стоимостью',
    UpgradedExperience: 'Эксклюзивные права на добавленную стоимость, опыт модернизации',
    OfflineTranslation: 'Перевод оффлайн',
    NoInternet: 'Нет необходимости в сети · Мгновенный перевод · Безопасность и надежность',
    GoToSubscribe: 'Подписаться',
    AudioAndVideoCall: 'Звуковые / видеозвонки',
    RealTimeCall: 'Голосовой перевод в реальном времени · Доступность общения',
    BaseService: 'Основные услуги',
    AIAssistant: 'Функции: синхронный переводчик · Помощник по обслуживанию конференций · Помощник ИИ',
    LanguagesSetting:'Параметры языка',
    languages1:'Упрощенный китайский',
    languages2:'Китайский стиль',
    languages3:'Английский язык',
    languages4:'Японский язык',
    languages5:'Корейский язык',
    languages6:'Русский язык',
    languages7:'Испанский язык',
    languages8:'Французский язык',
    languages9:'Немецкий язык',
    languages10:'Португальский язык',
    languages11:'Итальянский язык',
    languages12:'Турецкий язык',
    languages13:'Вьетнамский язык',
    languages14:'Индонезийский язык',
    languages15:'Индийский язык',
    languages16:'Арабский язык',
    languages17:'Тайский язык',
    languages18:'Персидский язык',
  },
  Login: {
    ToLogin: 'Регистрация',
    PhoneLogin: 'Номер мобильного',
    EmailLogin: 'Почтовый ящик',
    PhonePlaceholder: 'Пожалуйста, введите номер телефона.',
    EmailPlaceholder: 'Enter email',
    Code: 'Код проверки',
    and: 'А',
    BeforeText: 'Создание учетной записи означает ваше согласие и соблюдение',
    UserAgreement: 'Пользовательское соглашение',
    privacy: 'Политика конфиденциальности',
    errorMessage: 'Ошибка кода проверки',
    readTitle: 'Читайте и соглашайтесь со следующим соглашением',
    readBefore: 'Чтобы обеспечить безопасность ваших персональных данных, сначала прочтите и согласитесь.',
    cancel: 'Отменить',
    agree: 'Согласен и продолжается',
    error1:'Введите действительный адрес почтового ящика',
    error2:'Пожалуйста, введите правильный номер телефона.',
    error3:'Введите код проверки.',
    success:'Регистрация завершена'
  },
  OffLinePage: {
    title: 'Перевод оффлайн',
    NoInternet: 'Нет необходимости в сети · Мгновенный перевод · Безопасность и надежность',
    ServiceLife: 'Срок службы',
    forever: 'Постоянное использование',
    describe: 'Описание подписки',
    describeItem1: '1.Функция оффлайн - перевода для одноразовой оплаты, постоянного использования, права использования следуют за устройством Bluetooth, если устройство заменяется, необходимо повторно подписаться на код обмена оффлайн - перевода.',
    describeItem2: '2. Лицензионный код не подлежит возврату после подписки.',
    describeItem3: '3.Поддерживает 10 языков: китайский, английский, немецкий, японский, корейский, хинди, тайский, испанский, французский, русский.',
    quantity: 'Количество',
    payType: 'Способы оплаты',
    card: 'Банковские карточки',
    wx: 'Микросхема',
    GooglePay: 'Google Pay',
    subscribe: 'Подписка',
    RMB: '¥',
    confirm:'Подтверждение',
    cardNumber:'Номер карты',
    periodOfValidity:'Срок действия',
    safetyCode:'Код безопасности',
    name:'Имя',
    yearAndMonth:'Год / месяц',
    message1:'Количество не может быть 0',
    popTip:'Теплый совет',
    popText1:'Пожалуйста, внимательно прочитайте и поймите.',
    popText2:'Платные оффлайн - переводы',
    popText3:'Я прочитал и согласился.',
    popText4:'Прочитал и согласился.',
  },
  AudioVideoPage: {
    title: 'Звуковые / видеозвонки',
    RealTime: 'Голосовой перевод в реальном времени · Доступность общения',
    describe: 'Описание подписки',
    describeItem1: '1.Функция перевода аудио - и видеозвонков заключается в пополнении количества минут покупки, количества минут вычисляются с момента включения звонка, права следуют за учетной записью, если вы вошли в другую учетную запись, необходимо перезарядить.',
    describeItem2: '2.Подключение и привязка различных устройств после пополнения учетной записи могут использоваться как обычно.',
    describeItem3: '3. Функция перевода аудио - и видеозвонков не подлежит возврату после пополнения.',
    payType: 'Способы оплаты',
    card: 'Банковские карточки',
    wx: 'Микросхема',
    GooglePay: 'Google Pay',
    subscribe: 'Подписка',
    RMB: '¥',
    sale: 'Скидка',
    confirm:'Подтверждение',
    time1:'Секунда',
    time2:'Минуты',
    time3:'Часы',
    time4:'Боже.',
    time5:'Месяц',
    time6:'Год',
  },
  OffLineResult: {
    title1: 'Перевод оффлайн',
    title2: 'Звуковые / видеозвонки',
    title3: 'Основные услуги',
    success: 'Подписка удалась',
    fail: 'Ошибка подписки',
    stock:'Обменный код в резерве',
    saveTitle: 'Сохранить код обмена и перейти в приложение для обмена',
    code: 'Код обмена',
    tip1: 'Этот код используется только для обмена функций оффлайн - перевода.',
    tip2: 'Этот код используется только для перевода звуковых / видеозвонков.',
    tip3: 'Этот код используется только для обмена базовых услуг.',
    save: 'Сохранить',
    time: 'Время подписки:',
    copy: 'Копирование',
    copySuccess: 'Копировать успешно',
    loading:'Загрузка',
    paySuccess:'Оплата успешно'
  },
  RedemptionList: {
    title: 'Мой код обмена.',
    view: 'Посмотреть',
    time: 'Время подписки:',
  },
  MyRedemption: {
    title: 'Мой код обмена.',
    code: 'Код обмена',
    time: 'Время подписки:',
    copy: 'Копирование',
    tip1: 'Этот код используется только для обмена функций оффлайн - перевода.',
    tip2: 'Этот код используется только для перевода звуковых / видеозвонков.',
    tip3: 'Этот код используется только для обмена базовых услуг.',
    save: 'Сохранить',
    success:"Операция прошла успешно"
  },
  basePage:{
    error1:'Информация о товарах отсутствует',
    message1:'Пожалуйста, выберите товар.',
    title:'Основные услуги',
    function:'Функции: синхронный переводчик · Помощник по обслуживанию конференций · Помощник ИИ',
    describe: 'Описание подписки',
    describe1:'1. После возобновления основных услуг, таких как синхронный письменный перевод, помощники по обслуживанию заседаний, срок действия следует за оборудованием, и если оборудование заменяется, требуется повторное продление.',
    describe2:'2. Возобновляемая плата за базовые услуги не подлежит возмещению.',
    payType: 'Способы оплаты',
    card: 'Банковские карточки',
    wx: 'Микросхема',
    GooglePay: 'Google Pay',
    subscribe: 'Подписка',
    RMB: '¥',
    sale: 'Скидка',
    month:'Месяц',
    confirm:'Подтверждение',
    month1:'Месяц',
    month2:'Полгода',
    month3:'Год'
  },
  ...ruLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default ru;
